import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Button, message, Spin, Typography } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import logger from '../../services/logger';

const UserInfo = () => {
  const { user, token } = useAuth();
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/v1/auth/me');
      setUserDetails(response.data);
    } catch (error) {
      logger.error('Kullanıcı bilgileri alınamadı:', error);
      message.error('Kullanıcı bilgileri alınamadı.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <Typography.Title level={2}>
          <BugOutlined /> Kullanıcı Bilgileri Debug
        </Typography.Title>
      </div>
      
      <Card title="Auth Context Bilgileri" style={{ marginBottom: 16 }}>
        <Descriptions column={1}>
          <Descriptions.Item label="Token">
            {token ? `${token.substring(0, 20)}...` : 'Token yok'}
          </Descriptions.Item>
          <Descriptions.Item label="User">
            {user ? JSON.stringify(user, null, 2) : 'User yok'}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Backend'den Gelen Kullanıcı Bilgileri">
        {loading ? (
          <Spin />
        ) : (
          <div>
            <Button onClick={fetchUserDetails} style={{ marginBottom: 16 }}>
              Bilgileri Yenile
            </Button>
            {userDetails ? (
              <Descriptions column={1}>
                <Descriptions.Item label="ID">{userDetails.id}</Descriptions.Item>
                <Descriptions.Item label="Kullanıcı Adı">{userDetails.username}</Descriptions.Item>
                <Descriptions.Item label="E-posta">{userDetails.email}</Descriptions.Item>
                <Descriptions.Item label="Ad Soyad">{userDetails.full_name}</Descriptions.Item>
                <Descriptions.Item label="Rol">{userDetails.role}</Descriptions.Item>
                <Descriptions.Item label="Aktif">{userDetails.is_active ? 'Evet' : 'Hayır'}</Descriptions.Item>
                <Descriptions.Item label="Son Giriş">
                  {userDetails.last_login ? new Date(userDetails.last_login).toLocaleString('tr-TR') : 'Hiç'}
                </Descriptions.Item>
              </Descriptions>
            ) : (
              <p>Kullanıcı bilgileri yüklenemedi</p>
            )}
          </div>
        )}
      </Card>
    </div>
  );
};

export default UserInfo;
